var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgRoadFilled = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.462 4H9.605c-1.035 0-1.96.653-2.303 1.627l-4.5 12.704a2.088 2.088 0 0 0 1.967 2.78h7.693v-2.444a1.22 1.22 0 0 1 1.222-1.223 1.22 1.22 0 0 1 1.222 1.223v2.444H22.6a2.086 2.086 0 0 0 1.967-2.78l-4.5-12.704A2.447 2.447 0 0 0 17.763 4h-2.857v2.444a1.22 1.22 0 0 1-1.222 1.223 1.22 1.22 0 0 1-1.222-1.223V4zm2.444 7.333v2.445A1.22 1.22 0 0 1 13.684 15a1.22 1.22 0 0 1-1.222-1.222v-2.445a1.22 1.22 0 0 1 1.222-1.222 1.22 1.22 0 0 1 1.222 1.222z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoadFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/road-filled.560dc9dc.svg";
export { ForwardRef as ReactComponent };